import { createHistogramAssistedChatPoint } from '..';
import { createCallsTermData, createHistogramCallsPoint } from '../../..';
export * from './testkit';
export var createMyStatisticsInsightsApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/analytics/me");
    return {
        getOverview: function (dto) { return http.post("".concat(url, "/overview"), dto); },
        getNumberOfRepliesCumulative: function (dto) { return http.post("".concat(url, "/agentReplies/cumulative"), dto); },
        getNumberOfRepliesHistogram: function (dto) { return http.post("".concat(url, "/agentReplies/histogram"), dto); },
        getSolvedTicketsCumulative: function (dto) { return http.post("".concat(url, "/solvedTickets/cumulative"), dto); },
        getSolvedTicketsHistogram: function (dto) { return http.post("".concat(url, "/solvedTickets/histogram"), dto); },
        getCallVolumeCumulative: function (dto) { return http.post("".concat(url, "/callVolume/cumulative"), dto); },
        getCallVolumeHistogram: function (dto) { return http.post("".concat(url, "/callVolume/histogram"), dto); },
        getHandleTimeCumulative: function (dto) { return http.post("".concat(url, "/handleTime/cumulative"), dto); },
        getHandleTimeHistogram: function (dto) { return http.post("".concat(url, "/handleTime/histogram"), dto); },
        getAssistedCallsCumulative: function (dto) { return http.post("".concat(url, "/assistedCalls/cumulative"), dto)
            .then(function (data) { return ({
            value: data.value.map(createCallsTermData),
            compared: data.compared && data.compared.map(createCallsTermData)
        }); }); },
        getAssistedCallsHistogram: function (dto) { return http.post("".concat(url, "/assistedCalls/histogram"), dto)
            .then(function (data) {
            var value = Object.keys(data.value).reduce(function (acc, key) {
                acc[key] = data.value[key].map(createHistogramCallsPoint);
                return acc;
            }, {});
            var compared = data.compared && Object.keys(data.compared)
                .reduce(function (acc, key) {
                acc[key] = data.compared[key].map(createHistogramCallsPoint);
                return acc;
            }, {});
            return { value: value, compared: compared };
        }); },
        getNewPublishedArticlesCumulative: function (dto) {
            return http.post("".concat(url, "/publishedArticles/cumulative"), dto);
        },
        getNewPublishedArticlesHistogram: function (dto) { return http.post("".concat(url, "/publishedArticles/histogram"), dto); },
        getArticleUpdatesCumulative: function (dto) { return http.post("".concat(url, "/updatedArticles/cumulative"), dto); },
        getArticleUpdatesHistogram: function (dto) { return http.post("".concat(url, "/updatedArticles/histogram"), dto); },
        getTotalChatsAnsweredHistogram: function (dto) { return http.post("".concat(url, "/servedChats/histogram"), dto); },
        getTotalChatsAnsweredCumulative: function (dto) { return http.post("".concat(url, "/servedChats/cumulative"), dto); },
        getTimeToEndChatHistogram: function (dto) { return http.post("".concat(url, "/timeToEndChat/histogram"), dto); },
        getTimeToEndChatCumulative: function (dto) { return http.post("".concat(url, "/timeToEndChat/cumulative"), dto); },
        getJoinedChatsHistogram: function (dto) { return http.post("".concat(url, "/assistedChats/histogram"), dto).then(function (data) {
            var value = Object.keys(data.value).reduce(function (acc, key) {
                acc[key] = data.value[key].map(createHistogramAssistedChatPoint);
                return acc;
            }, {});
            var compared = data.compared && Object.keys(data.compared)
                .reduce(function (acc, key) {
                acc[key] = data.compared[key].map(createHistogramAssistedChatPoint);
                return acc;
            }, {});
            return { value: value, compared: compared };
        }); },
        getJoinedChatsCumulative: function (dto) { return http.post("".concat(url, "/assistedChats/cumulative"), dto); },
        getChatRepliesHistogram: function (dto) { return http.post("".concat(url, "/chatReplies/histogram"), dto); },
        getChatRepliesCumulative: function (dto) { return http.post("".concat(url, "/chatReplies/cumulative"), dto); },
        getServedChatsHistogram: function (dto) { return http.post("".concat(url, "/servedChats/histogram"), dto); },
        getSatisfactionScoreHistogram: function (dto) { return http.post("".concat(url, "/satisfactionScore/histogram"), dto); },
        getSatisfactionScoreCumulative: function (dto) { return http.post("".concat(url, "/satisfactionScore/cumulative"), dto); }
    };
};
//# sourceMappingURL=index.js.map